
export const checkout = {
  thankYou: {
    header: "Thank you for your purchase!",
    content: {
      emailSent: "A copy has been sent to:",
      download: "Download"
    },
    consultation: {
      title: "Consultation date:",
      details: "The appointment details and meeting link have been sent to:"
    },
    video: {
      title: "Expected completion:",
      details: "We'll notify you by email when your video is ready:"
    },
    question: {
      title: "Thank you for your question!",
      response: "We'll respond within 24 hours",
      email: "The answer will also be sent to your email:"
    }
  },
  form: {
    error: {
      title: "Error",
      requiredFields: "Please fill in all required fields"
    }
  }
};
